import React from "react";

import ContentIngestionReportingView from "./ContentIngestionReportingView";

const MetadataDiscoveryReport = () => {
  return <ContentIngestionReportingView />;
};

export default MetadataDiscoveryReport;
